module.exports = __webpack_public_path__ + "static/walt-341af4638f113884d1103cb1e0a0cfe3.png";